import { apiRequest, postApiRequest } from './_tools';

export function fetchPlacements({ page, itemsPerPage, sort, filter }) {
  return apiRequest(`/api/placementsWithPaging?page=${page}&itemsPerPage=${itemsPerPage}` +
    `&id=${filter.id}` +
    `&appId=${filter.appId}` +
    `&appName=${filter.appName}` +
    `&sortKey=${sort.key}` +
    `&order=${sort.order}`)
    .catch(({ error }) => Promise.reject(error));
}

export function updatePlacement({ placementId, revShare }) {
  return postApiRequest(`/api/placements/admin/${placementId}`, { revShare })
    .catch(({ error }) => Promise.reject(error));
}



/** WEBPACK FOOTER **
 ** ./js/core/api/placements.js
 **/